// Mock data for Generational Wealth Society

export const brandData = {
  name: "GENERATIONAL WEALTH SOCIETY",
  tagline: "We are the next generation of inheritors.",
  heroVideoUrl: "https://videos.pexels.com/video-files/3214132/3214132-uhd_2560_1440_25fps.mp4",
  heroVideoAlt: "https://videos.pexels.com/video-files/5747406/5747406-uhd_2560_1440_25fps.mp4",
  logoUrl: "https://customer-assets.emergentagent.com/job_a451e5de-2816-44d8-b560-8ea33a6fc963/artifacts/l6gv28zz_4.pdf",
};

export const navigation = {
  left: [],
  right: [
    { name: "ABOUT", href: "/about" },
    { name: "EXPERIENCE", href: "/experience" },
    { name: "MEMBERSHIP", href: "/membership" },
  ],
};

export const heroContent = {
  headline: "GENERATIONAL WEALTH SOCIETY",
  subheadline: "",
  description: "Empowering the next generation of inheritors.",
  ctaText: "Discover More",
};

export const aboutContent = {
  title: "Who We Are",
  paragraphs: [
    "What is passed down to us becomes the future we shape. Our journey asks for responsibility, and the courage to redefine what it means to lead.",
    "Each of us carries a story — not of possession, but of impact. To walk this path is not a solitary act.",
    "Growth unfolds when we learn from one another, when we challenge, when we share, when we hold ourselves accountable among peers who understand.",
  ],
};

export const valuesContent = {
  title: "Our Pillars",
  values: [
    {
      id: "explore",
      title: "EXPLORE",
      description: "New ideas and perspectives to shape our own understanding.",
      image: "https://images.unsplash.com/photo-1573544198019-f2fe658145d5",
    },
    {
      id: "experience",
      title: "EXPERIENCE",
      description: "Challenges and moments that push us beyond the familiar.",
      image: "https://images.unsplash.com/photo-1559385301-0187cb6eff46",
    },
    {
      id: "engage",
      title: "ENGAGE",
      description: "With each other to form deep bonds where trust and support thrive.",
      image: "https://images.unsplash.com/photo-1610375461246-83df859d849d",
    },
  ],
};

export const manifestoContent = {
  lines: [
    "HERE, BEING REAL MATTERS MORE THAN APPEARANCES",
    "HERE, WE MOVE FORWARD TOGETHER",
  ],
};

export const ctaContent = {
  title: "Join the Society",
  description: "A collective built for the next generation of inheritors who seek not only recognition, but depth, clarity, and the strength.",
  buttonText: "Get In Touch",
};

export const footerContent = {
  copyright: "© 2025 Generational Wealth Society. All rights reserved.",
  links: [
    { name: "Privacy Policy", href: "/app-privacy-policy" },
    { name: "Terms of Use", href: "/app-terms" },
  ],
  socialLinks: [
    { name: "LinkedIn", href: "#" },
    { name: "Instagram", href: "#" },
  ],
};
